import { ROLE } from '../brand';

/** Texto de rol en español (perfil, ayudas). */
export function formatUserRoleForDisplay(
  roleName: string | null,
  isSuperAdmin: boolean,
): string {
  if (isSuperAdmin) return 'Super administrador';
  if (roleName === ROLE.TENANT_ADMIN) return 'Administrador de la organización';
  if (roleName === ROLE.OPERATOR) return 'Operador de cobros';
  return roleName || '—';
}

/** Usuario con layout solo de cobro (p. ej. operador, sin sección admin en el cajón). */
export function isPayOnlyUser(roleName: string | null, isSuperAdmin: boolean): boolean {
  if (isSuperAdmin) return false;
  if (roleName === ROLE.TENANT_ADMIN) return false;
  return true;
}
